<div *ngIf="normalPlaceholder" id="spinner">
  <sk-three-bounce ng-reflect-background-color="#273c46">
    <div _ngcontent-c9="" class="sk-three-bounce">
      <div _ngcontent-c9="" class="sk-child sk-bounce1" style="background-color: rgb(39, 60, 70);"></div>
      <div _ngcontent-c9="" class="sk-child sk-bounce2" style="background-color: rgb(39, 60, 70);"></div>
      <div _ngcontent-c9="" class="sk-child sk-bounce3" style="background-color: rgb(39, 60, 70);"></div>
    </div>
  </sk-three-bounce>
  <div class="warning-message" *ngIf="warningMessage && showWarningMessage">
    <span>{{warningMessage}}</span>
  </div>
</div>

<div class="timeline-item placeholder" *ngIf="facebookPlaceholder">
  <div class="animated-background facebook">
    <div class="user-avatar">
      <div class="background-masker img-circle"></div>
      <div class="background-masker display-country-flag"></div>
    </div>
    <div class="background-masker lg-text-placeholder influencer-name"></div>
    <div class="d-flex flex-row channel-info">
      <div class="background-masker sm-text-placeholder mr-10 channel-info-country"></div>
      <div class="background-masker sm-text-placeholder ml-10 channel-info-follower"></div>
      <div class="d-flex flex-auto"></div>
    </div>
    <div class="d-flex flex-row mb-20 platform-list">
      <div class="background-masker circle-placeholder"></div>
      <div class="background-masker circle-placeholder"></div>
      <div class="background-masker circle-placeholder"></div>
      <div class="background-masker circle-placeholder"></div>
      <div class="background-masker circle-placeholder"></div>
    </div>
    <div class="row mt-15 influencer-kip-overview">
      <div class="col-md-4">
        <div class="background-masker lg-text-placeholder mb-15"></div>
        <div class="background-masker xs-text-placeholder mt-10"></div>
      </div>
      <div class="col-md-4">
        <div class="background-masker lg-text-placeholder mb-15"></div>
        <div class="background-masker xs-text-placeholder mt-10"></div>
      </div>
      <div class="col-md-4">
        <div class="background-masker lg-text-placeholder mb-15"></div>
        <div class="background-masker xs-text-placeholder mt-10"></div>
      </div>
    </div>
  </div>
</div>

<div class="timeline-item placeholder" *ngIf="textPlaceholder">
  <div class="animated-background facebook">
    <div class="background-masker number-placeholder mb-15"></div>
  </div>
</div>

<div class="timeline-item placeholder" *ngIf="groupPlaceholder">
    <div class="d-flex animated-background facebook">
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
      <div class="background-masker group-avatar-placeholder"></div>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-loader/achoo-loader.component.html